<ul class="tabmenu-container {{fullWidth?'tabmenu-full-width':''}}" cdkDropList cdkDropListOrientation="horizontal" cdkDropListLockAxis="x" [cdkDropListDisabled]="!canDragAndDrop" (cdkDropListDropped)="drop($event)" [ngClass]="cssClass">
  <li [class]="'tabmenu-item ' + itemCssClass + ' '+item.cssClass" cdkDrag [ngStyle]="{ width: itemWidth }" *ngFor="let item of dataSource;trackBy:trackBy"
    (click)="onItemClick(item)" [ngClass]="{
      'tabmenu-item_active': value === item.value,
      'tabmenu-item_disabled': item.disabled === true
    }">
    <span class="tabmenu-label" *ngIf="!item.textTpl">{{
      item.text
    }}</span>
    <ng-container *ngIf="item.textTpl">
      <span class="tabmenu-label">
        <div *ngTemplateOutlet="item.textTpl;context:getContext(item)"></div>
      </span>
    </ng-container>
    <ng-container *ngIf="item.moveBtnTpl">
      <span cdkDragHandle class="abs r0 t0">
        <div *ngTemplateOutlet="item.moveBtnTpl;context:getContext(item)"></div>
      </span>
    </ng-container>
  </li>
</ul>